import axios from 'axios'
import Cookies from 'js-cookie'
import {Constant} from '../common/constant'
import NProgress from 'nprogress'
import store from '../vuex/store'
import * as types from '../vuex/mutation-types'
import router from '../router'

const CSRF_COOKIE_NAME = 'csrftoken'
const CSRF_HEADER_NAME = 'X-CSRFToken'
const TOKEN_NAME = Constant.TOKEN_NAME
const REFRESH_TOKEN = Constant.REFRESH_TOKEN
const MENU_PERMISSIONS = Constant.MENU_PERMISSIONS
const EDIT_PERMISSIONS = Constant.EDIT_PERMISSIONS
const READ_PERMISSIONS = Constant.READ_PERMISSIONS
const APP_USR = Constant.APP_USR

const session = axios.create({
  xsrfCookieName: CSRF_COOKIE_NAME,
  xsrfHeaderName: CSRF_HEADER_NAME,
  timeout: 50000
})

// before a request is made start the nprogress
session.interceptors.request.use(config => {
  NProgress.start()
  return config
})

// before a response is returned stop nprogress
session.interceptors.response.use(response => {
  NProgress.done()
  return response
})

session.interceptors.response.use(
  response => response,
  error => {
    const {status} = error.response
    if (status === 403 || status === 401) {
      Cookies.remove(TOKEN_NAME)
      Cookies.remove(REFRESH_TOKEN)
      Cookies.remove(APP_USR)
      Cookies.remove(MENU_PERMISSIONS)
      Cookies.remove(EDIT_PERMISSIONS)
      Cookies.remove(READ_PERMISSIONS)
      store.commit(types.UPDATE_PERMISSION, {edit_permissions: [], read_permissions: []})
      store.commit(types.UPDATE_MENU, {menu_permissions: []})
      store.commit(types.UPDATE_USER, {userInfo: null})
      store.commit(types.LOGOUT)
      router.push({name: 'Login'})
    }
    return Promise.reject(error)
  }
)

axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true'
axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*'

let token = Cookies.get(TOKEN_NAME)
if (token) {
  session.defaults.headers['Authorization'] = `Bearer ${token}`
}

export default session



// WEBPACK FOOTER //
// ./src/api/session.js